import dashboardPartnerData from '@/mixins/dashboardPartnerData.js';

export default {
  mixins: [dashboardPartnerData],
  computed: {
    partnerName() {
      return this.partnerData?.name;
    },
    partnerId() {
      return this.partnerData?.id;
    }
  }
};
